// extracted by css-extract-rspack-plugin
export default {"originals-fields-group":"V8uPxZ","originalsFieldsGroup":"V8uPxZ"};